module.exports = __webpack_public_path__ + "media/images/down_brown-e5f65bc9808c118e63c4590154bace7e.png";